<template>
  <div class="animate-panel"  data-child="hpanel" data-effect="fadeInDown">
    <div class="hpanel no-margins">
      <template v-if="authors.length !== 0">
        <div class="panel-body no-padding ">
          <table style="width: 100%;margin-top: 5px">

            <tr style="height: 25px">
              <th class="visible-md visible-lg visible-xl col-md-2 col-lg-2 col-xl-1 text-center">

                <div class="btn-group">
                  <button type="button" class="btn btn-info btn-outline btn-xs" style="padding-left: 10px;padding-right: 0;" @click="allChecked = !allChecked">
                    <div class="checkbox checkbox-info" style="margin: 2px 0 0 0;">
                      <input type="checkbox" :checked="allChecked">
                      <label></label>
                    </div>
                  </button>
                  <button type="button" class="btn btn-info btn-outline btn-xs dropdown-toggle dropdown-toggle-split" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style="padding-top: 4px;padding-bottom: 4px;">
                    <i class="fa fa-caret-down"></i>
                  </button>
                  <ul class="dropdown-menu pull-right" aria-labelledby="dropdownMenu1" style="float: right" >
                    <li v-if="allChecked === false"><a role="button" @click="allChecked = true"><i class="far fa-check-square text-success"></i> Select All</a></li>
                    <li v-if="allChecked === true"><a role="button" @click="allChecked = false"><i class="far fa-square-o text-danger"></i> Unselect All</a></li>
                    <li  class="dropdown-submenu-copyto dropdown-submenu">
                      <a tabindex="-1" class="copyToItem" href="#"><i class="fa fa-copy text-warning"></i> Copy Selected to <span class="fa fa-caret-down"></span></a>
                      <ul id="copyToListUl" class="dropdown-menu copyToListUl">
                        <template v-if="context.projectsLists && context.projectsLists.length">
                          <li>
                            <span class="copyToProjectTitle m-b"><u>Select SubProject:</u></span>
                            <span class="" style="float: right">
                                <button class="btn btn-xs btn-info" @click="fullScreen"><i id="iconCopyExpertFullScreen" class="glyphicon glyphicon-resize-full"></i></button>
                              </span>
                          </li>
                          <li v-for="(project, key) in context.projectsLists" v-if="project.lists && project.lists.length"  :key="key">
                            <div style="font-size: 12px; padding: 3px 20px">
                              <span class="text-info copyToProjectLi">{{truncateString(project.name,20)}}</span>
                              <ul>
                                <li v-for="(list, listKey) in project.lists"   :key="'list-'+listKey" :id="'list-id-'+list.id" class="copyToListLi" :title="'Subproject '+list.title">
                                  <a role="button" @click="copyAllSelected(list.id)"><i class="far fa-circle text-info"></i> {{truncateString(list.title,18)}}</a>
                                </li>
                              </ul>
                            </div>
                          </li>
                        </template>
                        <template v-else>
                          <li style="padding: 15px">Project list empty</li>
                        </template>
                      </ul>
                    </li>
                    <li><a role="button" @click="deleteAllSelected"><i class="fas fa-trash text-danger"></i> Delete Selected</a></li>
                    <li class="divider"></li>
                    <li><a role="button" @click="context.exportCsv('author')"><i class="fas fa-file-excel text-info"></i> Export All Csv</a></li>
                  </ul>
                </div>
              </th>
              <th class="col-xs-4 col-md-3 col-lg-1 col-xl-2"><span role="button" @click="changeSort('expert')">Expert <i style="padding-left: 15px" class="fa fa-sort"></i></span></th>
              <th class="col-xs-5 col-md-5 col-lg-3 col-xl-3">
                <table class="table" style="width: 100%;">
                  <td class="col-xs-5 col-md-5 col-lg-5 text-center" style="vertical-align: middle">
                    <span role="button" @click="changeSort('country')">Country <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                  <td class="col-xs-7 col-md-7 col-lg-7" style="vertical-align: middle">
                    <span role="button" @click="changeSort('affiliation')">Affiliation <i style="padding-left: 15px" class="fa fa-sort"></i></span>
                  </td>
                </table>
              </th>
              <th class="col-lg-4 col-xl-4 visible-lg visible-xl"><span>Top document</span></th>
              <th class="col-md-1 col-xs-1 visible-lg visible-xl"></th>
              <th class="col-xs-2 col-md-2 col-lg-1 col-xl-1 text-center"><span>Action</span></th>

            </tr>
          </table>
          <div v-if="authors.length !== 0" >
            <div v-for="(author, key) in authors" v-if="author && key < context.nbItemsDisplay" :key="key + '-' + author.authorID" class="clearfix ">
              <div class="col-xs-12 top-document" data-toggle="collapse" :data-target="'#collapse-'+ author.authorID" aria-expanded="false" :aria-controls="'collapse-'+ author.authorID">

                <author-top v-model="authors[key]" :context="context" :key="key + '-' + author.authorID + '-' + author.checked + '-' + author.followSearchId" @authorChecked="authorChecked"/>
                <div style="bottom: -9px;position: absolute;width: 100%">
                  <span style="margin-left: 49%;background-color: white;">
                    <button style="border-radius: 50px;font-size: 0.6rem;" class="btn btn-info btn-xs">
                    <i class="fa fa-chevron-down"></i>
                    </button>
                  </span>
                </div>
              </div>
              <div class="col-xs-12 collapse" :id="'collapse-'+ author.authorID" style="padding: 20px" >
                <document-author v-model="authors[key].docs" :author="author"
                                 :pubDateSelected="context.pubDateSelected" :context="context"/>
              </div>

            </div>
            <div class="text-center" style="padding: 25px">
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayMore">Display more</button>
              <button class="btn btn-primary btn-xs" :class="authors.length > context.nbItemsDisplay ? '' : 'disabled'" @click="context.displayAll">Display all</button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>
<style scoped>
.dropdown-submenu {
  position: relative;
}

.dropdown-submenu .dropdown-menu {
  top: 0;
  left: 160px;
  margin-top: -1px;
  overflow-y: scroll;
  max-height: 200px;
  width: 250px;
  text-transform: capitalize;
}

.copyToListLi {
  margin: 5px;
  overflow-y: hidden;
}

.copyToProjectLi {
  background: #f9f9f9;
  width: 300px;
  padding: 2px 5px;
  display: table-cell;
  overflow-y: hidden;
}

#copyToListUl.fullScreen {
  display: block;
  z-index: 1005;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: white;
  padding: 25px;
  max-height: inherit;
}

#copyToListUl.fullScreen .copyToProjectLi {
  width: 100%;
  display: block;
  padding: 10px 20px;
  font-size: medium;
}

#copyToListUl.fullScreen .copyToListLi {
  width: 100%;
  display: block;
  padding: 5px 10px;
  font-size: medium;
}

.copyToProjectTitle {
  display: none;
}

#copyToListUl.fullScreen .copyToProjectTitle {
  display: contents;
  font-size: x-large;
}
</style>
<script>
import AuthorTop from './../documents/AuthorTop'
import DocumentAuthor from '../documents/DocumentAuthor'

export default {
  components: {
    DocumentAuthor,
    AuthorTop
  },
  props: ['context', 'value', 'listType', 'changeSort'],
  name: 'ListAuthorsSelected',
  watch: {
    value: function (val) {
      this.authors = val
    },
    allChecked: function (val) {
      this.authors.forEach((author) => {
        author.checked = val
      })
      this.authors = Object.assign([], this.authors)
    }
  },
  data () {
    return {
      authors: null,
      allChecked: false
    }
  },
  methods: {
    authorChecked: function (author) {
      let index = this.authors.indexOf(author)

      if (typeof index !== 'undefined') {
        this.authors[index].checked = true
      }
    },
    deleteAllSelected: function () {
      this.authors.forEach((author) => {
        if (author.checked === true) {
          this.context.removeAuthor(author)
        }
      })
    },
    copyAllSelected: function (copyToListId) {
      this.authors.forEach((author) => {
        if (author.checked === true) {
          this.context.copyToList(author, copyToListId)
        }
      })
      this.removeFullScreen()
      $('.dropdown-submenu-copyto a.copyToItem').next('ul').hide()
    },
    truncateString: function (str, num) {
      if (typeof str !== 'undefined' && str.length > num) {
        return str.slice(0, num) + ' ...'
      } else {
        return str
      }
    },
    fullScreen: function (e) {
      let list = $('.dropdown-menu.copyToListUl')
      let iconFullScreen = $('#iconCopyExpertFullScreen')

      if (list.hasClass('fullScreen')) {
        list.removeClass('fullScreen')
        iconFullScreen.removeClass('glyphicon-resize-small')
        iconFullScreen.addClass('glyphicon-resize-full')
      } else {
        list.addClass('fullScreen')
        iconFullScreen.addClass('glyphicon-resize-small')
        iconFullScreen.removeClass('glyphicon-resize-full')
      }
      e.stopPropagation()
      e.preventDefault()
    },
    removeFullScreen: function () {
      let list = $('.dropdown-menu.copyToListUl')
      let iconFullScreen = $('#iconCopyExpertFullScreen')

      if (list.hasClass('fullScreen')) {
        list.removeClass('fullScreen')
        iconFullScreen.removeClass('glyphicon-resize-small')
        iconFullScreen.addClass('glyphicon-resize-full')
      }
    }
  },
  mounted () {
    $(document).on('click', '.filter .dropdown-menu', function (e) {
      e.stopPropagation()
    })

    $('.dropdown-submenu-copyto a.copyToItem').on('mouseover', function (e) {
      $(this).children('span').toggleClass('fa-caret-down').toggleClass('fa-caret-right')
      $(this).next('ul').show()
      e.stopPropagation()
      e.preventDefault()
    })

    $('.dropdown-submenu-copyto').on('mouseleave', (e) => {
      this.removeFullScreen()
      $(this).find('a.copyToItem').children('span').removeClass('fa-caret-right').addClass('fa-caret-down')
      $('.dropdown-submenu-copyto a.copyToItem').next('ul').hide()
      e.stopPropagation()
      e.preventDefault()
    })

    $(document).keyup((e) => {
      if (e.key === 'Escape') {
        this.removeFullScreen()
      }
    })
  },
  beforeMount () {
    this.authors = this.value
    this.authors.forEach((author) => {
      author.checked = false
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ListAuthors/ListAuthorsSelected.vue